import SingleSubmitForm from './single-submit-form';

export default class NonBlankForm extends SingleSubmitForm {
  constructor() {
    super(...arguments);

    this.$field = this.$element.find('.nonBlankForm-field');
  }

  shouldSubmit() {
    const pattern = /^$|^\s+$/;

    if (super.shouldSubmit(...arguments) && !pattern.test(this.$field.val())) {
      return true;
    } else {
      return false;
    }
  }
}
